import { Container, Graphics } from "pixi.js";
import { HORIZON, outdoor, tree } from "./common.js";

/**
 * El paradero de la avenida principal.
 *
 * El bus está dibujado SOBRE la zona de la puerta a UBEP (x 660-810, y 380-440), y
 * ése es todo el truco: subirse tiene que ser pisar el estribo que se ve. Si el bus
 * se mueve de sitio en el dibujo, hay que mover también esa zona con F2 — o volverá a
 * ser una puerta invisible flotando al lado de un bus decorativo.
 */
export function paradero(): Container {
  const scene = outdoor({ ground: 0x8f9296, sky: 0x9ec9e8, hedge: 0x4c9c5b });

  // La avenida, más ancha que la vía interna: es la que cruza el campus entero.
  const avenue = new Graphics();
  avenue.rect(0, HORIZON - 4, 960, 70).fill(0x5a5f63);
  for (let i = 0; i < 20; i++) {
    avenue.rect(i * 52 + 8, HORIZON + 28, 28, 6).fill({ color: 0xf2e8d8, alpha: 0.8 });
  }
  scene.addChild(avenue);

  scene.addChild(shelter());
  scene.addChild(bus());
  scene.addChild(tree(70, HORIZON + 60, 0.9));

  return scene;
}

/** La marquesina: techo, columnas y el poste de la parada. */
function shelter(): Container {
  const s = new Container();

  const g = new Graphics();
  g.rect(280, 250, 300, 14).fill(0x2f6fb2);
  g.rect(288, 264, 10, 90).fill(0x8f979c);
  g.rect(562, 264, 10, 90).fill(0x8f979c);
  g.rect(300, 276, 260, 60).fill({ color: 0xdfe9f2, alpha: 0.55 });

  g.rect(620, 236, 8, 120).fill(0x8f979c);
  g.circle(624, 228, 22).fill(0x2f6fb2).stroke({ width: 3, color: 0xf4f7fa });
  s.addChild(g);

  return s;
}

/** El bus, parado con la puerta abierta justo sobre la zona de embarque. */
function bus(): Container {
  const b = new Container();

  const body = new Graphics();
  body.roundRect(600, 250, 330, 150, 10).fill(0xe8c33c).stroke({ width: 4, color: 0x8c7a2a });
  // Franja de la ESPOL a media altura.
  body.rect(600, 316, 330, 16).fill(0x1b3f6b);
  // Ventanillas.
  for (let i = 0; i < 4; i++) {
    body.rect(618 + i * 62, 268, 48, 38).fill({ color: 0x2b3a47, alpha: 0.75 });
  }
  // Ruedas, asomando bajo el chasis.
  body.circle(660, 400, 20).fill(0x2b2b2b);
  body.circle(880, 400, 20).fill(0x2b2b2b);
  b.addChild(body);

  // La puerta abierta: el hueco oscuro que coincide con la zona del catálogo.
  const doorway = new Graphics();
  doorway.rect(690, 340, 90, 68).fill(0x1d2730);
  doorway.rect(690, 340, 6, 68).fill(0x8c7a2a);
  doorway.rect(774, 340, 6, 68).fill(0x8c7a2a);
  b.addChild(doorway);

  return b;
}
